import React, { useEffect, useState, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import BudgetAnalysis from "../../components/BudgetAnalysis/BudgetAnalysis";
import DashboardBox from "../../components/DashboardBox/DashboardBox";
import { get_dashboard_data, exportSubActivityDetailedPPAReport } from "../../helper/Api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainFilter from "../../components/Tools/MainFilter";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import SubHeader from "../../components/Subheader/Subheader";
import { useNavigate } from "react-router-dom";
import {
  Modal as MuiModal,
  Box,
  Button,
  TextField,
  Typography,
  Stack,
} from "@mui/material";

const Dashboard = () => {
  const { authData, financialYears } = useSelector((state) => state.authData);
  const [loading, setLoading] = useState(false);
  const prevDataRef = useRef({
    account_name: "",
    bank_name: "",
    branch_name: "",
    ifsc_code: "",
    account_type: "",
    account_no: "",
    account_balance: "",
    balance_date: "",
    interest: "",
    interest_date: "",
    added_by: "", 
  });
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const fy_list = financialYears.payload.fy_list;
  const reloadList = useRef(false);
  const [bankAccount, setBankAccount] = useState(false);
  const [data, setData] = useState({
    curr_surrender: {
      approved_surrender: 0,
      pending_surrender: 0,
      surrender_i_got: 0,
    },
    total_provisional_budget: {
      provisional_budget: 0,
      released_budget: 0,
    },
    currenyFyUtilization: 0,
    prevFyUtilization: 0,
    prevYearBalance: 0,
    payable_expanses: 0,
    sanctioned_amount: 0,
    accumulated: [
      {
        deduction: 0,
      },
    ],
    reimbursement_details: [
      {
        under_approval: 0,
      },
      {
        payment_approval: 0,
      },
    ],
    salary_details: [
      {
        under_approval: 0,
      },
      {
        payment_approval: 0,
      },
    ],
    stats: [
      {
        budget_allocation_pending_count: 0,
        invoice_pending_count: 0,
        invoice_payment_pending_count: 0,
        dbt_pending_approval_count: 0,
        dbt_pending_payment_approval: 0,
      },
    ],
  });
  const fyId = localStorage.getItem('globalDateId');
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const [filterPayload, setFilterPayload] = useState({
      searchStr: "",
      fromDate: "",
      toDate: "",
      dateColumn: "",
      department_id: "",
      tier: ""
  })

  // Export PPA report modal states
  const [showPpaExportModal, setShowPpaExportModal] = useState(false);
  const [ppaExportPayload, setPpaExportPayload] = useState({ fromDate: "", toDate: "" });
  const [ppaExportSubmitting, setPpaExportSubmitting] = useState(false);
  const [ppaExportErrors, setPpaExportErrors] = useState({});

  useEffect(() => {
    loadFullDashboard(fyId);
  }, [fyId, authData])

  const loadFullDashboard = async (fy_id, payload = filterPayload) => {
    await fetch_dashboard_data(fy_id, payload.department_id || authData.user.department_id);
  };

  const handleFinancialYearChange = async (e) => {
    const val = e.target.value;
    localStorage.setItem("globalDateId", val);
    await loadFullDashboard(val);
  };

  const fetch_dashboard_data = async (
    fyId = null,
    departmentId = null,
    tier = null
  ) => {
    try {
      setLoading(true);
      const { data } = await get_dashboard_data({
        fy_id: fyId,
        department_id: departmentId,
        department_level: tier,
      });
      if (data.status) {
        setData(data);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something Went Wrong", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something Went Wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleEditAccount = (data) => {
    prevDataRef.current = data;
    setBankAccount(true);
  };

  const changePopUpState = (cState, reload = false) => {
    setBankAccount(cState);
    if (reload) {
      reloadList.current = true;
    }
  };
  const handleFilterClick = async () => {
    setOpen(false);
    await loadFullDashboard(fyId);
  };

  

  const [divider, setDivider] = useState(1);

  // filter setup or states

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleInput = async (e) => {
      const {name, value} = e.target;
      setFilterPayload((prev) => ({
          ...prev, [name]: value
      }));
  }

  const handleFilterRemove = async (name) => {
     const newPayload = {
      ...filterPayload,
      [name]: "",
    };
    setFilterPayload(newPayload);
    loadFullDashboard(fyId, newPayload);
  }

    const [divisionNumber, setDivisionNumber] = useState(1);
    useEffect(()=>{
      setDivider(divisionNumber);
    },[divisionNumber])

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    // Returns FY start year for a given YYYY-MM-DD date (Indian FY: Apr-Mar)
    function getFyStartYearFromDate(dateStr) {
      if (!dateStr) return null;
      const [y, m] = String(dateStr).split("-").map((v) => Number(v));
      if (!y || !m) return null;
      return m >= 4 ? y : y - 1;
    }

    const openPpaExportModal = () => {
      setPpaExportErrors({});
      setPpaExportPayload({ fromDate: "", toDate: "" });
      setShowPpaExportModal(true);
    };

    const closePpaExportModal = () => {
      setShowPpaExportModal(false);
      setPpaExportSubmitting(false);
      setPpaExportErrors({});
    };

    const handlePpaExportInput = (e) => {
      const { name, value } = e.target;
      setPpaExportPayload((prev) => ({ ...prev, [name]: value }));
      setPpaExportErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // API trigger placeholder: yahin pe tum API integrate kar dena
    const triggerPpaExportApi = async (fromDate, toDate) => {
      // Example:
      // return await export_ppa_report({ from_date: fromDate, to_date: toDate, fy_id: fyIdRef.current });
      return { status: true };
    };

    const downloadFile = (url) => {
      try {
          if (!url) {
          throw new Error("Empty URL");
          }

          const parsedUrl = new URL(url);

          // allow only https
          if (parsedUrl.protocol !== "https:") {
          throw new Error("Invalid protocol");
          }

          // Use the same pattern as Schemes.jsx (works reliably here)
          const link = document.createElement("a");
          link.href = parsedUrl.href;
          link.download = "PPA-Subactivity-Expense.xlsx";
          link.rel = "noopener noreferrer";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

      } catch (err) {
          // Fallback: open URL in same tab
          try {
            if (url) window.location.assign(url);
          } catch (_) {
            // ignore
          }
          toast.error("Unable to start download", {
            position: toast.POSITION.TOP_CENTER,
          });
      }
  };

    const handlePpaExportSubmit = async () => {
      const errors = {};
      if (!ppaExportPayload.fromDate) errors.fromDate = "From date is required";
      if (!ppaExportPayload.toDate) errors.toDate = "To date is required";

      if (Object.keys(errors).length) {
        setPpaExportErrors(errors);
        toast.error("Please select both From Date and To Date", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      if (ppaExportPayload.fromDate > ppaExportPayload.toDate) {
        setPpaExportErrors({
          fromDate: "From date cannot be greater than To date",
          toDate: "To date cannot be less than From date",
        });
        toast.error("From Date should be less than or equal to To Date", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const fromFyStart = getFyStartYearFromDate(ppaExportPayload.fromDate);
      const toFyStart = getFyStartYearFromDate(ppaExportPayload.toDate);
      if (fromFyStart && toFyStart && fromFyStart !== toFyStart) {
        const fromLabel = `${fromFyStart}-${fromFyStart + 1}`;
        const toLabel = `${toFyStart}-${toFyStart + 1}`;
        setPpaExportErrors({
          fromDate: `From date is in FY ${fromLabel}`,
          toDate: `To date is in FY ${toLabel}`,
        });
        toast.error("Both dates should be from same financial year", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      try {
        setLoading(true);
        setPpaExportSubmitting(true);
        const res = await exportSubActivityDetailedPPAReport(authData.user.department_details.id, ppaExportPayload.fromDate, ppaExportPayload.toDate);
        if (res?.data?.status === false) {
          toast.error(res?.message || "Something Went Wrong", {
            position: toast.POSITION.TOP_CENTER,
          });
          setPpaExportSubmitting(false);
          return;
        }
        downloadFile(res?.data?.url);
        closePpaExportModal();
        setLoading(false);
      } catch (e) {
        setLoading(false);
        setPpaExportSubmitting(false);
        toast.error("Something Went Wrong", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    };

  return (
    <>
    {loading && <div > <Spinner/> </div>}
    <SubHeader fy_list={fy_list} setDivisionNumber={setDivisionNumber} handlePageTrigger={handlePageTrigger}/>
    <div className="row" style={{ padding: "10px 16px" }}>
      <div className="col-md-6">
          <h4 style={{ color: "#28326f", margin:0}}>Dashboard</h4>
          <CustomBreadcrumbs linksArray={[]} title="Dashboard"/>
      </div>
      <div className="col-md-6">
        <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
          {
            authData.user.department_details.department_level === 'T1' && 
            <button type="button" className="navigation_button" ><span className="fs-14px" onClick={() => navigate("/consolidate-dashboard")}>Consolidate Dashboard</span></button>
          }
        </div>
      </div>
    </div>
    
    <div className="overflow-x-hidden" style={{ backgroundColor: "#F1F1F1" }}>
      <BudgetAnalysis
        isShowPopup={bankAccount}
        previewBankAccountData={prevDataRef.current}
        handlePopUpState={changePopUpState}
        handleFilter={handleFilterClick}
        setDivider={setDivider}
        fy_list={fy_list}
      />

      <DashboardBox
        openFilterModal={setOpen}
        handleYearDropdown={handleFinancialYearChange}
        data={data}
        showPopupFun={handleEditAccount}
        listReload={reloadList.current}
        dividerNumber={divider}
        filterPayload={filterPayload}
        fy_list={fy_list}
        handleFilterRemove={handleFilterRemove}
      />

      {/* ========================================filter modal==================================================== */}

      <MainFilter 
        open={open} 
        handleClose={handleClose} 
        handleInput={handleInput} 
        handleOpen={handleOpen}
        filterPayload={filterPayload}
        handleFilterClick={handleFilterClick}
      />

      {/* Export PPA Report Modal */}
      <MuiModal open={showPpaExportModal} onClose={closePpaExportModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92vw", sm: 560 },
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 3,
            outline: "none",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Export PPA Report
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 2 }}>
            <TextField
              fullWidth
              type="date"
              label="From Date"
              name="fromDate"
              value={ppaExportPayload.fromDate}
              onChange={handlePpaExportInput}
              InputLabelProps={{ shrink: true }}
              error={!!ppaExportErrors.fromDate}
              helperText={ppaExportErrors.fromDate || " "}
              required
            />
            <TextField
              fullWidth
              type="date"
              label="To Date"
              name="toDate"
              value={ppaExportPayload.toDate}
              onChange={handlePpaExportInput}
              InputLabelProps={{ shrink: true }}
              error={!!ppaExportErrors.toDate}
              helperText={ppaExportErrors.toDate || " "}
              required
            />
          </Stack>

          <Stack direction="row" spacing={1.5} justifyContent="flex-end">
            <Button variant="outlined" onClick={closePpaExportModal} disabled={ppaExportSubmitting}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handlePpaExportSubmit} disabled={ppaExportSubmitting}>
              {ppaExportSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Stack>
        </Box>
      </MuiModal>
    </div></>
  );
};


export default Dashboard;

